<feedback-display-header [title]="'feedback-session-comment-sync-event-viewer_slide-timings' | translate"></feedback-display-header>

<section class="scrollable-feedback-section">
	<!-- Sync event comments -->
	@if (hasSyncEventComments$ | async) {
		<comment-viewer
			class="inverse"
			[playerSync]="playerSync"
			[tags]="tags"
			[hideCommentReply]="true"
		></comment-viewer>
	}

	<!-- Zero state-->
	@if ((hasSyncEventComments$ | async) === false) {
		<ngx-zero-state class="add-comment-zero-state">
			<p zero-state-title [translate]="'feedback-session_comment-zero-state_add-comments_title'"></p>
			<p zero-state-subtext [innerHTML]="'feedback-session-comment-sync-event-viewer_state-description' | translate"></p>
			<div zero-state-graphic-bottom>
				<span class="ficon-app-presentation"></span>
			</div>
		</ngx-zero-state>
	}
</section>

<footer>
	<button
		class="secondary-btn done-btn"
		(click)="done()"
		data-cy="slide-done"
		translate="common_done">
	</button>
</footer>
